import UniversalNotification from './UniversalNotification'

export default UniversalNotification
